import moment from "moment";

export const checkYear = (value) => moment().diff(moment(value),'years') >= 21
